import { useNotifications } from "../Contexts/NotificationContext";
import NotificationPanel from "./NotificationPanel.jsx";

export default function Navbar() {
  return (
    <div style={{
      background: "#fff",
      padding: "10px 24px",
      borderBottom: "1px solid #e4e7ec",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      height: "60px",
      boxSizing: "border-box"
    }}>
      <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 700 }}>Workspace</h3>
      <NotificationPanel />
    </div>
  );
}